import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_onboarding-alert_banner-view';
/**
 * Tracks view event of alert banner below navigation
 */
export function trackRetailerOnboardingAlertBannerView(Alert_Banner_Type_string, Message_string2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Alert_Banner_Type_string, Message_string2 },
    });
}
